import React, { useState, useEffect } from 'react';
import './Cotton.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function CottonLearn(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [cottons, setCottons] = useState(true);
  const [cotton1, setCotton1] = useState(true);
  const [cotton2, setCotton2] = useState(false);
  const [cotton3, setCotton3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [displayLearnVideo, setDisplayLearnVideo] = useState(false);
  const [cottonNum, setCottonNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState('');
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const cotton1Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy1.svg');
  const cotton2Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy2.svg');
  const cotton3Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandy3.svg');
  const stick1Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick1.svg');
  const stick2Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick2.svg');
  const stick3Img = generateImageUrl('images/Module19Images/Unit4_Mod4_CottonCandyStick3.svg');
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  // CSS code for the back button


  const displayVideo = (video, num) => {
    setlearnVideo(video);
    setCottonNum(num);
    setCottons(false);
    setDisplayLearnVideo(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  useEffect(() => {
    sleep(700).then(() => {
      bounceSound.play()
    });
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      <div
        className='cottonScene'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={learnVideo}
            back={'unit4'}
            background={props.background}
            close={()=>{setDisplayLearnVideo(false); setCottons(true);}}
            ended={() => {
              setDisplayLearnVideo(false);
              setCottons(true);
              if (cottonNum === 1) {
                setEffect1('');
                setEffect2('bounceIcons');
                setCotton2(true);
                sleep(700).then(() => {
                bounceSound.play()
                });
              } else if (cottonNum === 2) {
                setEffect2('');
                setEffect3('bounceIcons');
                setCotton3(true);
                sleep(700).then(() => {
                bounceSound.play()
                });
              } else if (cottonNum === 3) {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              }
            }}
          />
        )}
        {cottons && (
          <div className='monkey_cotton'>
            <div className='cottons'>
              {cotton1 && (
                <div
                  className='cotton_stick1'
                  onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                      displayVideo(props.learnVideo1, 1);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='cotton1'
                    id={effect1}
                    src={cotton1Img}
                  />
                  <br />
                  <img alt='' className='stick1' src={stick1Img} />
                </div>
              )}
              {cotton2 && (
                <div
                  className='cotton_stick2'
                  onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                      displayVideo(props.learnVideo2, 2);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='cotton2'
                    id={effect2}
                    src={cotton2Img}
                  />
                  <br />
                  <img alt='' className='stick2' src={stick2Img} />
                </div>
              )}
              {cotton3 && (
                <div
                  className='cotton_stick3'
                  onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                      displayVideo(props.learnVideo3, 3);
                    });
                  }}
                >
                  <img
                    alt=''
                    className='cotton3'
                    id={effect3}
                    src={cotton3Img}
                  />
                  <br />
                  <img alt='' className='stick3' src={stick3Img} />
                </div>
              )}
            </div>
            {<img alt='' className='animateMonkey' src={generateImageUrl('images/Module19Images/monkey_holding.png')} />}
          </div>
        )}
      </div>
    </>
  );
}
